export default __webpack_public_path__ + "static/media/10.a7c8c426.jpg";